/**
 * 重庆市金泰新型防水材料有限公司-数据
 */
//重庆市金泰新型防水材料有限公司
const jtcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp1.png";
const jtcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp2.png";
const jtcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp3.png";
const jtcp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp4.png";
const jtcp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp5.png";
const jtcp6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp6.png";
const jtcp7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp7.png";
const jtcp8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp8.png";

const jtbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg1.png";
const jtbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg2.png";
const jtbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg3.png";
const jtbg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg4.png";
const jtbg5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg5.png";
const jtbg6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg6.png";
const jtbg7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg7.png";
const jtbg8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg8.png";
const jtbg9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg9.png";
const jtbg10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg10.png";
const jtbg11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg11.png";
const jtbg12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg12.png";
const jtbg13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg13.png";
const jtbg14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg14.png";
const jtbg15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg15.png";
const jtbg16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg16.png";
const jtbg17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg17.png";
const jtbg18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtbg18.png";
const jtlb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtlb1.png";
const jtlb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtlb2.png";
const jtlb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtlb3.png";
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
export default {
    homeData: {
		herderBanner: [jtlb1, jtlb2, jtlb3],
		//企业logo
		logo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/logo/jtlogo.png",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtgs1.png",
		isShowVrModal: false,
		isShowVr: false,
		vRurl: "https://fs.m2.com.cn/home/20240171",
		isVideo: false,
		videoLogo: "",
		videoUrl: "",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `重庆市金泰新型防水材料有限公司，成立于2001年，注册资金5023万，注册地位于重庆市永川区三教镇工业区，办公总部位于重庆市九龙坡区科城路智博中心，分公司及生产研发基地位于重庆市綦江区永城镇，是专业从事新型建筑防水材料的开发、设计及生产，集生产与施工为一体、销售与指导相结合、施工与保修相关联的综合性企业。防水防腐保温工程专业承包一级资质。`,
		//公司官网
		website: "www.cqjtfs.com",
		operatingStatus: "正常在业",
		//经营品类
		categories:
			"空调设备及零部件、净化设备及零部件、通风设备及零部件、风机及零部件、防火阀、排烟阀、防火排烟阀、消防排烟风机、消声器、机电设备的生产、销售、安装；镀锌风管、玻璃钢制品销售；及以上产品的进出口业务；建筑机电安装工程、人防工程施工。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
		//公司地址
		companyAddress: "重庆市九龙坡区科城路渝高智博中心10-7",
		site: "重庆市九龙坡区",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "5023万人民币",
		//成立日期
		establishment: "2001-5-11",
		//经营品牌
		brand: "金泰",
		//主营产品
		mainProducts: "生产、销售防水材料、保温材料；防水防腐保温工程专业承包壹级；销售化工原料、建材、钢材、五金、汽车配件。",
		//企业名称
		headerTitle: "重庆市金泰新型防水材料有限公司",
		moreInfoName: "重庆市金泰新型防水材料有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `现款现结、预付款、货到付款`,
		//工厂地址
		factoryAddress: "重庆市九龙坡区科城路渝高智博中心10-7",
		//工厂人数
		factoryHeadcount: "58",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "省市布局1-2个",
		factoryHeadcount: "80亩",
		capacity: "1460万.5亿元",

		//联系负责人
		person: "石方倩 ",
		//联系电话
		contactNumber: "18723061270",
		//资质证书
		qualificationList: [
			{
				name: "安全生产许可证",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtzz1.jpg",
			},
			{
				name: "建筑业企业资质",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtzz2.png",
			},
			{
				name: "营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtzz3.jpg",
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "全国产品和服务质量诚信示范企业",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtry1.jpg",
			},
			{
				name: "全国防水行业质量领先品牌",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtry2.jpg",
			},
			{
				name: "全国防水行业质量领先企业",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtry3.jpg",
			},
			{
				name: "全国质量检验稳定合格产品",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtry4.jpg",
			},
			{
				name: "全国质量检验信得过产品",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtry5.jpg",
			},
			{
				name: "全国质量信誉保证产品",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtry6.jpg",
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "中冶建工集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jthb1.png",
				desc: "",
			},
			{
				name: "中国中铁股份有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jthb2.png",
				desc: "",
			},
			{
				name: "华润置地发展有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jthb3.png",
				desc: "",
			},
			{
				name: "中铁建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jthb4.png",
				desc: "",
			},
			{
				name: "中机中联工程有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jthb5.png",
				desc: "",
			},
			{
				name: "重庆建工集团有限责任公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jthb6.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 1,
				num: 1,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 1,
				num: 1,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
    listData: {
		productList: [
			{ name: "SBS改性沥青防水卷材", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp1.png" },
			{
				name: "自粘聚合物改性沥青防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp2.png",
			},
			{
				name: "高分子自粘胶膜（HDPE）防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp3.png",
			},
			{
				name: "种植屋面用耐根穿刺防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp4.png",
			},

			{
				name: "水泥基渗透结晶型防水涂料",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp5.png",
			},
			{ name: "非固化橡胶沥青防水涂料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp6.png" },
			{ name: "聚合物水泥基防水涂料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp7.png" },
			{ name: "单组份聚氨酯防水涂料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtcp8.png" },
		],
		navList: [
			{
				name: "防水卷材",
				isShow: false,
				id: 1,
				children: [
					"SBS改性沥青防水卷材",
					"自粘聚合物改性沥青防水卷材",
					"高分子自粘胶膜（HDPE）防水卷材",
					"种植屋面用耐根穿刺防水卷材",
				],
			},
			{
				name: "防水涂料",
				isShow: false,
				id: 2,
				children: ["水泥基渗透结晶型防水涂料", "非固化橡胶沥青防水涂料", "聚合物水泥基防水涂料", "单组份聚氨酯防水涂料"],
			},
		],
	},
    productDetailsData:		{
		SBS改性沥青防水卷材: {
			name: "SBS改性沥青防水卷材",
			img: jtcp1,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp1,
				},
			],
			price: "22",
			detailImgs: [jtcp1],
			modelNumberText: "SBS II PY PE PE3",
			brand: "金泰",
			describe: `产品简介
			弹性体改性沥青防水卷材(简称SBS防水卷材]是以乙烯-丁二烯-乙烯[SBS] 热塑弹性体改性石油沥青为浸涂材料，浸渍并涂盖聚酷毡 、玻纤毡、玻纤增强聚醋毡胎基，上表面覆以PE膜、细砂、矿物粒(片)科、金属铝箔等隔离材料，下表面覆以PE膜所制成的改性沥青防水材料。
			
			主要特点
			具有优良的耐高、低温性能，在-20C或-25C低温下仍然能保持着较好的柔性，低温、赛冷、潮湿条件下，不龟裂、不脆裂:同时在90C或105C高温下.材料无流淌、滴落。其温度适应范围广。
			有较好的机械强度和抗断裂性，在承受建筑结构允许范围内荷载应力和变形条件下不断裂。
			耐紫外线照射、耐老化寿命长，具有可靠的大气稳定性。特别是彩砂面卷材具有美观大方,经久耐用的优点。
			
			适用范围
			弹性体(SBS)改性沥青防水卷材适用于I级特别重要的民用建筑和对防水有特殊要求的工业建筑，是建设部2004年218号公告优先推荐的防水卷材之一。地下工程防水采用表面隔离材料为细砂的防水卷材。外需使用采用上表面隔离材料为不透明的矿物粒料的防水卷材
			玻纤毡卷材适用于多层防水中的底层防水。
			玻纤增强聚毡卷材可用于机械固定单层防水，但需通过抗风荷载实验。`,
			report: [jtbg1, jtbg2],
		},

		自粘聚合物改性沥青防水卷材: {
			name: "自粘聚合物改性沥青防水卷材",
			img: jtcp2,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp2,
				},
			],
			price: "24",
			detailImgs: [jtcp2],
			modelNumberText: "PY II PE 3.0 10",
			brand: "金泰",
			describe: `产品简介
			自粘聚合物改性沥青防水卷材(简称:自粘卷材]是以自钻聚合物改性沥青为基料，以聚乙烯膜(PE]、聚酷膜(PET]等为表面材料或无膜双面自粘[ D] 所制成的自粘防水卷材。
			
			适用范围
			自粘聚合物改性沥青防水卷材(简称:自粘卷材]是以自钻聚合物改性沥青为基料，以聚乙烯膜(PE]、聚酷膜(PET]等为表面材料或无膜双面自粘[ D] 所制成的自粘防水卷材。
			广泛应用于工业、民用建筑屋面、地下室、地铁、隧道、水利等各种防水工程。特别适用于不宜明火施工的油库、化工厂、纺织厂、粮库等防水工程。`,
			report: [jtbg3, jtbg4],
		},

		"高分子自粘胶膜（HDPE）防水卷材": {
			name: "高分子自粘胶膜（HDPE）防水卷材",
			img: jtcp3,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp3,
				},
			],
			price: "23.5",
			detailImgs: [jtcp3],
			modelNumberText: "P1.5",
			brand: "金泰",
			describe: `产品简介
			非沥青基高分子自粘胶膜(HDPE)防水卷材，是专门针对建筑防水预铺部位而研发的防水材料，卷材由高分子片材、高分子自粘胶膜、防粘晨组成，是为实现与硷结构融合而研发的非沥青基预铺防水卷材。自粘胶膜和混液土中未初凝的水泥浆在压力作用下，通过蠕变,相向渗过防粘层，形成有效的互穿粘结和巨大的分间力。混凝土固化后，预铺防水卷材和结构主体之间的空院得到牢靠的密封，消除了窜水通道，从根本上提高了防水的可靠度。
			
			产品特点
			预铺粘贴
			可与后续浇筑的混凝土粘为一体，长期湿泡下也依然密不可分，解决了预输(外防内贴）防水难题。
			粘贴可靠，便于维修
			防水卷材与后浇混凝土紧密粘结。卷材出现任何局部破坏，水都会被限定在很小的范围内，不窜流，即使出现个别的渗漏，渗漏点也会与破坏点一致，极易检修。
			基面要求低，节约工期
			湖湿甚至来找平基面均可施工，无须底涂，施工自由虚高，不受天气影响，雨季施工时，优势更加突出，能够强有力的保障工期。
			安全环保
			施工过程中省去溶剂和燃料，避免了环境污染和消防隐患，节约了资源。
			物理性能优异
			县备优异的抗控、延伸、耐根穿刺、耐候、透应基层变形能力强等性能
			最优性价比
			可与后浇混凝土结构层共同构筑超乎寻常的“皮肤”式的牢固防水体系，可靠性高，还可省去传统的水泥砂浆平层、细石湿凝土保护层，节省相关费用，系统造价低。
			
			适用范围
			地下室、地铁、隧道、水池、斜屋面及平屋面等部位防水，尤其适用于环境特殊、防水要求高的防水工程，种植绿化屋面，地下煤气、沼气等气体防泄漏。`,
			report: [jtbg5, jtbg6],
		},

		种植屋面用耐根穿刺防水卷材: {
			name: "种植屋面用耐根穿刺防水卷材",
			img: jtcp4,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp4,
				},
			],
			price: "31",
			detailImgs: [jtcp4],
			modelNumberText: "SBS II PY PE PE4",
			brand: "金泰",
			describe: `产品简介
			该产品分为钢胎基耐根穿刺防水卷材和化学阻根剂耐根穿刺防水卷材。铜胎基耐根穿刺防水卷材是以特殊复合铜胎基或铜箔胎基为卷材胎基，以SBS改性沥青为涂政涂料，两面覆以聚乙烯膜、细砂或矿物粒料为隔离材料制成的改性沥青防水卷材。化学阻根剂耐根穿刺防水卷材是以添加化学阻根剂，以SBS改性沥青为涂改涂料，两面覆以聚乙烯膜、细砂或矿物粒料为隔离材料制成的改性沥青防水卷材。
			
			产品特点
			具有防水盒阻止植物根穿透双重功能，能够承受植物根须穿刺，长久保持防水功能
			既防根穿刺，又不影响植物正常生长
			优异的耐高低温性能，冷热地区均适用
			可形成高强度防水层，抵抗压力水能力强，并耐穿刺、耐撕裂、耐疲劳
			抗拉强度高，改性沥青涂盖层厚度大，对基层收缩变形和开裂的适应能力强
			耐腐蚀、耐霉菌、耐侯性好
			热熔法施工，施工方便且热接缝可靠耐久
			
			主要用途
			适用于种植屋面及需要绿化的地下建筑物顶板的耐植物根系穿刺层，确保植物根系不对该层次以下部位的构造形成破坏，并有防水功能。`,
			report: [jtbg7, jtbg8, jtbg9, jtbg10],
		},

		水泥基渗透结晶型防水涂料: {
			name: "水泥基渗透结晶型防水涂料",
			img: jtcp5,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp5,
				},
			],
			price: "6500元/T",
			detailImgs: [jtcp5],
			modelNumberText: "CCCW C",
			brand: "金泰",
			describe: `产品简介
			水泥基渗透结品型防水涂料(CCCW C)，是以特种水泥、石英砂等为基料，
			掺入多种活性化学物质制成的粉状刚性防水材料，与水作用后，材料中含有的活
			性化学物质利用混凝土本身固有化学特性及多孔性，通过载体水向混凝土内部渗
			透，在混凝土中形成不溶于水的结品体，堵塞毛细孔道，从而使混凝土致密、防水
			
			性能特点
			永久的防水效果:属于无机材料，渗透入混凝土结构内部，与混凝土同寿命，且
			性能稳定。
			双重的防水性能:本产品所产生的渗透结品体，除了能够深入到混凝土结构内部
			堵塞结构孔缝外，作用在混凝土结构表面的涂层也具有很好的抗港作用。
			长久的自我修复功能:本产品防水涂层具有良好的粘结力，与混凝土结构基面可
			融为一体，其中的活性化学物质多年以后仍能被水激活，不断生长出新的渗透结
			品物来弥补修复因裂缝所带来的渗漏，具有长久的防水性能。
			具有防腐、耐老化、保护钢筋的作用:本产品的渗透结品体不影响混凝土的呼
			吸，在保护混凝土内部钢筋不受侵蚀的基础上延长了建筑物的使用寿命。
			快凝、早强、刚而不脆的特性: 本产品中掺入了无机骨料，增加了水化物的塑
			性，改变了早强活性化合物的硬脆性，所以本产品的固化物虽然是刚性的，但不
			会发脆、开裂。
			 环保无公害:水溶性化合物，能适用于饮用水、食品加工领域和游泳池、水库、
			蒂水池等建筑物项目。
			在潮湿基面条件下即可作业，施工简便、省时，综合成本低。
			
			适用范围
			适用于混凝土结构地下室及建筑基稿工程、隧道、地铁、桥雨、停车场、游
			泳池、厨卫间及混凝土预制构件等的平立面防水。`,
			report: [jtbg11, jtbg12],
		},

		非固化橡胶沥青防水涂料: {
			name: "非固化橡胶沥青防水涂料",
			img: jtcp6,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp6,
				},
			],
			price: "7500元/T",
			detailImgs: [jtcp6],
			modelNumberText: "--",
			brand: "金泰",
			describe: `产品简介
			1、非固化橡胶沥青防水涂料是我公司新开发生产的一种新型防水材料。
			该材料是以胶粉、高分子聚合物、沥青等材料通过专用改性剂、添加剂制造
			的单组份防水涂料。
			2、非固化橡胶沥青防水涂料与空气长期接触后不固化，不溶于水，粘结
			强度高，能适应复奈的施工作业面;并可自动找寻漏水部位修复已损坏的防
			水层，永久防漏;不含溶剂，满足国家安全、环保的要求。
			3、非固化橡胶沥青防水涂料具有突出的端变性能，防水性能好、耐老
			化，可采用涂抹、喷涂以及注浆堵漏等多种工法。可与卷材共同组成复合防
			水层；还可单独作为一道防水层，表面应付隔离层。
			
			应用范围
			产品适用于起伏较大、应力较大的基层和可预见性发生形变的部位，特别适
			用于不能使用明火施工、机械施工和冷粘剂施工的工程等。
			适用于混凝土、彩钢等屋面、地下、水池及隧道等防水工程。
			
			性能特点
			优异的基层适应性;
			材料可很好的适应结构变性，当基层开裂、拉伸防水层时，由非固化橡胶沥
			青防水层吸收应力，封闭基层的微细裂缝，确保整个防水系统长期保持完整
			性。
			突出的自愈合能力:
			当防水层收到外力作用被截破时，破坏点不会扩大，防水层底部也不会发生
			窜水现象，而且材料的端变性能自愈轻微的渗漏问题，提高了防水层的可靠
			性，减少了工程维护成本。
			优异的抗老化性、低温柔性、耐腐蚀性。
			钻结力强:
			可与不同基层粘结，即使在潮湿基面也有很好的粘结力
			良好的可施工性:
			图含量99%以上，加料、泵出，连续化施工，可一次涂抹至指定厚度，施工
			速度可达115㎡ /h。
			安全环保;
			无毒、无溶剂、施工无明火，安全环保。`,
			report: [jtbg13, jtbg14],
		},

		聚合物水泥基防水涂料: {
			name: "聚合物水泥基防水涂料",
			img: jtcp7,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp7,
				},
			],
			price: "10500元/T",
			detailImgs: [jtcp7],
			modelNumberText: "JS II",
			brand: "金泰",
			describe: `产品简介
			聚合物水泥基防水涂料(简称JS防水涂料)是以德国巴斯夫公司生产的高分子
			乳液和无机粉料科学配制而成,经水分挥发和水泥水化反应固化成膜的环保型双
			组分水性防水涂料，形成的防水层既具有有机材料良好的柔韧性,又有无机材料
			优异的耐久性，是建设部重点推广的防水产品。
			
			性能特点
			粘接力强，能在潮湿或干燥的多种材质基面上直接施工;
			涂层坚韧高强，耐水性、耐候性、耐久性优异;
			无毒、无味、无污染、施工安全、操作简单、是饮用水池防水的理想材料;
			可加颜料，以形成多彩涂层美化环境。
			
			适用范围
			该产品适用于新旧混凝土屋面、地下室、厕所、水库、游泳池、隧道、桥梁等工
			程防水，还可以在潮湿(无明水)或干操的砖石、金属、木材、塑料、玻璃、泡沫
			板、沥青、聚氨酷、SBS或APP卷材等基面上直接施工。
			I型适用于活动量较大的基层，I[型和I型适用于活动量较小基层。`,
			report: [jtbg15, jtbg16],
		},

		单组份聚氨酯防水涂料: {
			name: "单组份聚氨酯防水涂料",
			img: jtcp8,
			modelNumber: [
				{
					title: "暂无",
					img: jtcp8,
				},
			],
			price: "12000元/T",
			detailImgs: [jtcp8],
			modelNumberText: "PU S I N A",
			brand: "金泰",
			describe: `产品简介
			单组份水固化聚氨酷防水涂料是引进国外最先进的防水应用高科技技
			术，以进口材料为基本成份，无焦油、沥青、溶剂油等添加料，实现了
			以水做为固化剂的新型聚氨醋防水涂料。本产品无溶剂挥发，无毒、无
			味、无污染，是溶剂型聚氨酷防水涂料的升级产品，是一种100%的绿色
			环保型防水涂料。
			
			主要特点
			单组份施工安全是健康环保产品。
			100%环保产品，使用时加3~5%的水做固化剂反应成膜，无溶剂挥发，无
			毒、无味、无污染，对人体无害，适用于饮用水工程。
			流平性好、潮湿基面上可直接施工，具有极强的粘结力和附着力。
			涂膜弹性好、强度高、延伸率大、密实完整、无接缝，能克服基层微变
			形导致渗漏等问题。
			防水性能稳定，耐酸碱腐蚀、耐霉变、耐高低温 (-40℃~95℃)，具有
			优异的抗老化性能。
			根据客户需要，可定做各种颜色，达到防水装饰效果。
			
			产品范围
			该品广泛使用于工业、民用建筑屋面、地下室、厨卫间、饮用水池
			各种水利工程及地铁、隧道、桥梁、地下工程的防水、防渗。
			伸缩缝、施工缝、变形缝、穿墙管、落水口等的防水密封。`,
			report: [jtbg17, jtbg18],
		},
	},
    contactListData: {
		list: [
			{
				name: "李雄",
				position: "销售经理(西南区域)",
				id: "2",
				phoneNum: "18696707525",
				telephone: "--",
				color: "#007DFF ",
				email: "565580390@qq.com",
			},
			{
				name: "石方倩",
				position: "商务(西南区域)",
				id: "2",
				phoneNum: "18723061270",
				telephone: "--",
				color: "#23B095 ",
				email: "434327053@qq.com",
			},
		],
	},
    caseData: {
		list: [
			{
				name: "焦作市第二人民医院示范区医院门诊综合楼及病房楼EPC总承包",
				id: 1,
				price: "522.68万",
				time: "2022",
				site: "焦作市",
				type: "医院",
				unit: "中建新疆建工（集团）有限公司",
				desc: "张家口冰雪运动装备产业园位于张家口高新技术产业开发区内，规划总面积1160亩，其中2018年8月首期开发示范区435亩，后期预留725亩。示范区总建筑面积为24.7万平方米，基建总投资11.42亿元人民币。主要分为：轻型装备生产区、重型装备制造区、办公研发综合服务区、冰雪运动展览中心等四大板块。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtgc1.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht1.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht2.png" },
				],
				product:
					"防水卷材、防水涂料，4mm厚SBS耐根穿刺防水卷材（物理阻根）、2.0厚聚合物水泥防水涂料、4mm厚自粘SBS防水卷材(Ⅱ型）、2mm厚非固化橡胶沥青防水涂料、1.2厚高分子自粘胶膜（HDPE)防水卷材、水泥基渗透结晶型防水涂膜",
			},

			{
				name: "焦作市第二人民医院示范区医院医技楼EPC总承包项目",
				id: 2,
				price: "427.818678万",
				time: "2022",
				site: "焦作市",
				type: "医院",
				unit: "中建新疆建工（集团）有限公司",
				desc: "该工程主要包括如下内容：包括但不限于防水基层清理、修补防水基层表面、材料及工具机械的场内外水平及垂直运输、涂刷基层处理剂、材料接茬处及薄弱处处理、防水卷材粘贴、防水卷材铺贴、收头处理、闭水试验、避水试验、工完场清等与本分包工程相关的全部工作内容。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtgc2.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht3.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht4.png" },
				],
				product:
					"防水卷材、防水涂料，4mm厚SBS耐根穿刺防水卷材（物理阻根）、2.0厚聚合物水泥防水涂料、4mm厚自粘SBS防水卷材(Ⅱ型）、2mm厚非固化橡胶沥青防水涂料、1.2厚高分子自粘胶膜（HDPE)防水卷材、水泥基渗透结晶型防水涂膜",
			},

			{
				name: "悦湖产业新城-龙门秀苑项目一标段防水工程",
				id: 3,
				price: "999.34元",
				time: "2022",
				site: "成都市武侯区",
				type: "住宅",
				unit: "中国五冶集团有限公司",
				desc: `建筑用地面积 47924.23 平方米，总建筑面积178948.54 平方米。主要工程内容包括土石方与基坑支护工程、建筑与装饰工程、交安工程、电气工程、弱电工程、给排水工程、消防工程、暖通工程，电梯安装工程、抗震支架工程、总平的景观工程、绿化工程及水电安装工程等单位工程。
				3、建筑面积：地下建筑面积54572.83平方米，地上建筑面积124375.71平方米。`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtgc3.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht5.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht6.png" },
				],
				product:
					"防水卷材、防水涂料,聚氨酯防水涂料、自粘性交叉层压膜防水卷材、耐根穿刺高分子防水卷材、 聚合物水泥防水涂膜防水层",
			},

			{
				name: "昆明空港文化广场建设项目（EPC）设计施工总承包项目-第一标段工程-防水保温工程",
				id: 4,
				price: "766.4万",
				time: "2020",
				site: "昆明空港经济区",
				type: "--",
				unit: "中国五冶集团有限公司",
				desc: `第一标段（A-AP轴交1-32轴范围内的地下室、±0.000以上范围内的2号商业及3号秀场）〖含施工图及图纸会审与设计变更、技术核定单、任务通知单包含的全部内容〗工程施工图内相关的防水保温工程，包含地下室底板、顶板及侧壁防水、屋面及墙面防水保温工程`,
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtgc4.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht7.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/jt/jtht8.png" },
				],
				product: "防水保温材料,防水卷材、防水涂料",
			},
		],
	},
    evaluationData:{
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 6,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],

		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/cccf.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${14}.png`,
				// title: 'CCCF消防认证',
				subtitle: "CCCF消防认证",
				isShow: false,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${6}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${6}.png`,
				// title: '央视展播品牌',
				subtitle: "央视展播品牌",
				isShow: false,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${7}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${7}.png`,
				subtitle: "高新技术企业",
				isShow: false,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${9}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${9}.png`,
				subtitle: "CNAS实验室认证",
				isShow: false,
			},
		
		],
	},
    successfulBidderData: {
		info: [
			{
				name1: "建工八建-电子科技大学清水河校区学生公寓六期项目-防水专业分包任务",
				name2: "建工八建-电子科技大学清水河校区学生公寓六期项目-防水专业分包任务",
				name3: "物资采购",
				date: "2022/8/8",
			},
			{
				name1: "中冶建工二公司仙桃数据谷二期项目二标段S72-1/03地块工程项目防水工程专业分包",
				name2: "中冶建工二公司仙桃数据谷二期项目二标段S72-1/03地块工程项目防水工程专业分包",
				name3: "物资采购",
				date: "2021/12/4",
			},
			{
				name1: "中冶建工五公司中梁山组团J分区J05-11/05地块开发项目施工总承包项目保温防水工程专业分包",
				name2: "中冶建工五公司中梁山组团J分区J05-11/05地块开发项目施工总承包项目保温防水工程专业分包",
				name3: "物资采购",
				date: "2021/12/4",
			},
			{
				name1: "中冶建工五公司中梁山组团J分区J05-11/05地块开发项目施工总承包项目保温防水工程专业分包",
				name2: "中冶建工五公司中梁山组团J分区J05-11/05地块开发项目施工总承包项目保温防水工程专业",
				name3: "物资采购",
				date: "2021/12/4",
			},
			{
				name1: "中冶建工事业二部湖北省孝感高新区2018年棚户区改造项目（二期)董永北一标段防水工程专业分包",
				name2: "中冶建工事业二部湖北省孝感高新区2018年棚户区改造项目（二期)董永北一标段防水工程专业分包",
				name3: "物资采购",
				date: "2021/2/9",
			},
			{
				name1: "中冶建工五公司齐河县贸易大厦西片区棚户区改造项目防水工程专业分包",
				name2: "中冶建工五公司齐河县贸易大厦西片区棚户区改造项目防水工程专业分包",
				name3: "物资采购",
				date: "2021/1/12",
			},
			{
				name1: "中冶建工事业二部肥东县店埠镇都市花园一期安置小区建设项目北区防水工程专业分包",
				name2: "中冶建工事业二部肥东县店埠镇都市花园一期安置小区建设项目北区防水工程专业分包",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "中国五冶集团有限公司昆明空港文化广场建设项目(EPC)设计施工总承包项目-第一标段工程-防水保温工程",
				name2: "中国五冶集团有限公司昆明空港文化广场建设项目(EPC)设计施工总承包项目-第一标段工程-防水保温工程",
				name3: "物资采购",
				date: "2020/9/8",
			},
			{
				name1: "中冶建工事业二部孝感项目董永南地块一标段防水工程专业分包",
				name2: "中冶建工事业二部孝感项目董永南地块一标段防水工程专业分包",
				name3: "物资采购",
				date: "2020/6/23",
			},
			{
				name1: "中国建筑第七工程局有限公司西南分公司越洋广场防水工程",
				name2: "中国建筑第七工程局有限公司西南分公司越洋广场防水工程",
				name3: "物资采购",
				date: "2020/6/9",
			},
			{
				name1: "“依云水岸”住宅小区（二期）建设项目防水工程专业分包",
				name2: "“依云水岸”住宅小区（二期）建设项目防水工程专业分包",
				name3: "物资采购",
				date: "2020/5/28",
			},
			{
				name1: "五洲世纪文化创意中心项目防水专业分包工程招采",
				name2: "五洲世纪文化创意中心项目防水专业分包工程招采",
				name3: "物资采购",
				date: "2019/7/30",
			},
			{
				name1: "月亮庄建设项目新增部分防水工程",
				name2: "月亮庄建设项目新增部分防水工程",
				name3: "物资采购",
				date: "2019/6/5",
			},
			{
				name1: "仙桃数据谷三期二标段投融资建设工程项目防水工程（31#、34#）",
				name2: "仙桃数据谷三期二标段投融资建设工程项目防水工程（31#、34#）",
				name3: "物资采购",
				date: "2019/5/30",
			},
			{
				name1: "中冶建工六公司减震皮带轮产品项目防水工程专业分包",
				name2: "中冶建工六公司减震皮带轮产品项目防水工程专业分包",
				name3: "物资采购",
				date: "2019/4/12",
			},
			{
				name1: "朵力.迎宾大道项目F6—2地块SBS改性沥青防水卷材采购",
				name2: "朵力.迎宾大道项目F6—2地块SBS改性沥青防水卷材采购",
				name3: "物资采购",
				date: "2018/2/8",
			},
			{
				name1: "重庆电子工程职业学院 7#教学楼顶防水工程项目(第六次)分散采购",
				name2: "重庆电子工程职业学院 7#教学楼顶防水工程项目(第六次)分散采购",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "建筑物屋面漏水修缮采购",
				name2: "建筑物屋面漏水修缮采购",
				name3: "物资采购",
				date: "2014/9/15",
			},
			{
				name1: "市局大院建筑物屋面漏水修缮采购",
				name2: "市局大院建筑物屋面漏水修缮采购",
				name3: "物资采购",
				date: "2014/9/11",
			},
			{
				"企业名称": "重庆市金泰新型防水材料有限公司",
				"name1": "泸州白酒产业园区基础设施及公共服务配套设施改造项目--酒业园区污水处理厂扩建工程防水专业分包工程",
				"name4": "陕西建工安装集团有限公司",
				"name2": "泸州白酒产业园区基础设施及公共服务配套设施改造项目--酒业园区污水处理厂扩建工程",
				"name3": "专业分包",
				"date": "2020年6月9日",
				"out": true
			}
		],
	},
    lawData: {
		info: [
			{
				caseName: "重庆市金泰新型防水材料有限公司、中海外开发建设集团有限公司建设工程施工合同纠纷民事一审民事判决书",
				// 案号
				reference: "（2022）苏0831民初481号",
				// 案由
				cause: "建设工程施工合同纠纷",
				//身份
				identity: "原告",
				//类型
				caseType: "民事案件",

				date: "2022-10-31",
			},
			{
				caseName: "重庆市金泰新型防水材料有限公司与重庆市基础工程有限公司建设工程施工合同纠纷一审民事判决书",
				// 案号
				reference: "（2022）渝0119民初1108号",
				// 案由
				cause: "建设工程施工合同纠纷",
				//身份
				identity: "原告",
				//类型
				caseType: "民事案件",

				date: "2022-06-01",
			},
			{
				caseName: "重庆市金泰新型防水材料有限公司、叶治省建设工程分包合同纠纷民事二审民事判决书",
				// 案号
				reference: "（2022）川01民终13号",
				// 案由
				cause: "建设工程分包合同纠纷",
				//身份
				identity: "上诉人",
				//类型
				caseType: "民事案件",

				date: "2022-05-10",
			},
			{
				caseName:
					"重庆市金泰新型防水材料有限公司与贵州跃龙致远建筑工程有限公司,重庆卓煜实业有限公司建设工程施工合同纠纷一审民事判决书",
				// 案号
				reference: "（2021）渝0110民初15479号",
				// 案由
				cause: "建设工程分包合同纠纷",
				//身份
				identity: "原告",
				//类型
				caseType: "民事案件",

				date: "2022-04-29",
			},
			{
				caseName: "重庆市金泰新型防水材料有限公司与重庆精物实业(集团)有限公司建设工程合同纠纷执行裁定书",
				// 案号
				reference: "（2020）渝0116执5005号",
				// 案由
				cause: "建设工程分包合同纠纷",
				//身份
				identity: "申请执行人",
				//类型
				caseType: "执行案件",

				date: "2021-03-30",
			},
			{
				caseName: "陈万平、重庆市金泰新型防水材料有限公司建设工程分包合同纠纷二审民事判决书",
				// 案号
				reference: "（2020）川01民终2835号",
				// 案由
				cause: "建设工程分包合同纠纷",
				//身份
				identity: "被上诉人",
				//类型
				caseType: "民事案件",

				date: "2021-01-26",
			},
		],
	},
    tipData:{
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立10年以上",
			},
		],
	},
}